import makeApi from "../../libs/axios/api";
import {
  NotificationGetPayload,
  NotificationReadStatusPayload,
  type NotificationDetails,
} from "../../types/notifications";
const apiPromise = makeApi();

const getNotifications = async (
  notifications: NotificationGetPayload
): Promise<NotificationDetails[]> => {
  
  const api = await apiPromise;

  const params = new URLSearchParams({
    email: notifications.email || "",
    accountNumber: notifications.accountNumber || ""
  });
 
  const path = `/notification?${params.toString()}`;
  return api.get(path).then((response) => {
    return response.data as NotificationDetails[];
  });
};

const addReadStatusNotifications = async (
  notificationsStatus: NotificationReadStatusPayload
): Promise<string> => {
  
  const api = await apiPromise;

   const putBody = {
     userEmail : notificationsStatus.userEmail,
     notificationSentToId : notificationsStatus.notificationSentToId
  };

  const path = `/notification`;
  return api.put(path, putBody).then((response) => {
    return response.data as string;
  });
};
export {getNotifications, addReadStatusNotifications};
